import axios from "axios";
import Api from "../config/api/axios.urlcontext.js"

export default class avisoPrivacidad {
  async getAvisoPrivacidad(url) {
    try {
        // console.log('getMenuRendicionCtas(url');
        const res = await axios.get(Api.APP_URL_API+url);
        return res;
    } catch (error) {
        console.error(error.message);
    }
  }

  async getCarusel(url) {
    try {
        const res = await axios.get(Api.APP_URL_API+url);
        return res;
    } catch (error) {
        console.error(error.message);
    }
  }


}
